import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { toast, Toaster } from 'react-hot-toast';
import { get, isEmpty } from 'lodash';

import { setUserRole } from '@project/reducers/userRole-reducer/userRole.actions';
import { FormContainer, LoginForm } from '@project/components';
import { useAppDispatch } from '@project/reducers/store';
import { decodedToken, localStorageService, userAuthService } from '@project/services';
import { LoginProps } from '@project/types';
import config from '@project/config';
import { useRoleRedirect } from '@project/hooks';

const LoginScreen: React.FC = () => {
  const [rememberEmail, setRememberEmail] = useState('');
  const dispatch = useAppDispatch();
  const { search } = useLocation();
  const redirectByRole = useRoleRedirect();

  const _onLoginSubmit = (formData: LoginProps) => {
    localStorageService.setItem(
      config.rememberMeKey,
      get(formData, 'remember', false) ? get(formData, 'username') : '',
    );
    return userAuthService.login(formData);
  };

  const _onSuccess = async () => {
    const role = decodedToken.getRole();
    await dispatch(setUserRole(role));
    redirectByRole(role);
  };

  const reset = new URLSearchParams(search).get('reset');
  const unlock = new URLSearchParams(search).get('unlock');
  const rememberMe = localStorageService.getItem(config.rememberMeKey) ?? '';

  useEffect(() => {
    if (reset === 'successful') {
      toast.success('Password successfully reset', { duration: 5000 });
    } else if (unlock === 'successful') {
      toast.success('Account successfully unlocked', { duration: 5000 });
    } else if (reset === 'initialized') {
      toast.success('Password successfully set', { duration: 5000 });
    }
    setRememberEmail(`${rememberMe}`);
  }, [reset, unlock, rememberMe]);

  const loginFormInitialValues: LoginProps = {
    username: rememberEmail,
    password: '',
    remember: !isEmpty(rememberEmail),
    isLoading: false,
  };

  return (
    <FormContainer>
      <Toaster position="top-center" />
      <LoginForm
        initialValues={loginFormInitialValues}
        submitForm={_onLoginSubmit}
        onSuccess={_onSuccess}
        onFailure={() => null}
      />
    </FormContainer>
  );
};

export default LoginScreen;
